import { AddressLocationType } from '../../../../../components'
import { MaybeUserInfo } from '../../../../../types'
import { MaybeAddress, MaybeString, MaybeType } from '../../../../../utils'
import { AddressType } from '../../../../../utils/classes/graphql'
import { BaseDetailsAddress, BaseDetailsUser, ContactInputType } from '../types'

export const getContactOptions = <T extends string>(
  contactTypeValues: T[],
  contactTypeTranslationIdPart: string
) =>
  contactTypeValues.map((option: T) => ({
    value: option,
    translationId:
      'pages.ownInfoPage.baseDetails.' +
      contactTypeTranslationIdPart +
      '.types.' +
      option.toLowerCase()
  }))

export const getContactIndex = (name: string) => parseInt(name.split('.')[2])

export const isAddressTemporaryType = (addressType: MaybeType<AddressType>) =>
  addressType != null && addressType === AddressType.ValiaikosLt

export const isAddressLocationDomestic = (countryCode: MaybeString) =>
  countryCode !== undefined && countryCode === AddressLocationType.DOMESTIC

export const isAddressInput = (
  input: ContactInputType
): input is BaseDetailsAddress => {
  return (input as BaseDetailsAddress).maaKoodi !== undefined
}

export const createBaseDetailsUser = (
  user: MaybeUserInfo
): BaseDetailsUser => ({
  ...user,
  yhteystiedot: {
    ...user?.yhteystiedot,
    osoitteet: user?.yhteystiedot?.osoitteet?.map((osoite: MaybeAddress) => {
      return {
        ...osoite,
        addressLocation: isAddressLocationDomestic(osoite?.maaKoodi)
          ? AddressLocationType.DOMESTIC
          : AddressLocationType.FOREIGN
      }
    })
  }
})
